import React from 'react';
import {TextField} from '@mui/material';
import {FormFieldProps} from '../descriptor-types';

/**
 * Reusable form field component with consistent styling and behavior
 */
export const DescriptorFormField: React.FC<FormFieldProps> = ({
    label,
    value,
    onChange,
    onBlur,
    disabled = false,
    required = false,
    error = false,
    helperText = '',
    multiline = false,
    rows,
    maxLength,
    type = 'text',
    componentId
}) => {
    return (
        <TextField
            label={label}
            aria-label={label.toLowerCase()}
            type={type}
            variant="outlined"
            size="small"
            id={`${label.toLowerCase().replace(/\s+/g, '-')}-input-${componentId}`}
            autoComplete="on"
            value={value || ''}
            onChange={onChange}
            onBlur={onBlur}
            sx={{
                '& input': {
                    border: 'none',
                }
            }}
            slotProps={{
                input: {
                    'role': 'textbox',
                    'tabIndex': 0,
                    'aria-labelledby': `${label.toLowerCase().replace(/\s+/g, '-')}-input-${componentId}`,
                    'aria-label': label.toLowerCase()
                }
            }}
            disabled={disabled}
            required={required}
            fullWidth
            multiline={multiline}
            rows={rows}
            helperText={helperText}
            error={error}
            inputProps={{ maxLength }}
        />
    );
};